import { useFormContext } from "react-hook-form";
import clsx from "clsx";
import type { ShippingLabelFormValues } from "../../../../types/forms";

export default function PackageDetails() {
  const {
    register,
    formState: { errors },
  } = useFormContext<ShippingLabelFormValues>();

  return (
    <section>
      <h2 className="mb-5 text-lg font-medium text-gray-950">
        Package Details
      </h2>

      <div className="flex flex-col gap-5">
        <div className="flex flex-col gap-2 min-w-0">
          <label
            htmlFor="packageDetails-weight"
            className="block text-sm/6 font-normal text-gray-950"
          >
            Weight (lbs)
          </label>

          <input
            id="packageDetails-weight"
            type="number"
            inputMode="decimal"
            min="0"
            autoComplete="off"
            placeholder="e.g. 6.5"
            {...register("packageDetails.weight", {
              valueAsNumber: true,
              required: "Weight is required",
              validate: (value) => value > 0 || "Weight must be greater than 0",
            })}
            className={clsx(
              "block w-full rounded-xl border px-4 py-3.5 text-sm outline-none",
              "focus:ring-2 focus:ring-blue-500 placeholder:text-gray-500",
              errors.packageDetails?.weight
                ? "border-red-500 focus:ring-red-500"
                : "border-gray-200",
            )}
          />

          {errors.packageDetails?.weight && (
            <p className="text-sm text-red-500">
              {errors.packageDetails.weight.message}
            </p>
          )}
        </div>

        <div className="grid grid-cols-3 gap-3 md:gap-5">
          <div className="flex flex-col gap-2 min-w-0">
            <label
              htmlFor="packageDetails-length"
              className="block text-sm/6 font-normal text-gray-950"
            >
              Length (in)
            </label>

            <input
              id="packageDetails-length"
              type="number"
              inputMode="decimal"
              min="0"
              autoComplete="off"
              placeholder="L"
              {...register("packageDetails.length", {
                valueAsNumber: true,
                required: "Length is required",
                validate: (value) =>
                  value > 0 || "Length must be greater than 0",
              })}
              className={clsx(
                "block w-full rounded-xl border px-4 py-3.5 text-sm outline-none",
                "focus:ring-2 focus:ring-blue-500 placeholder:text-gray-500",
                errors.packageDetails?.length
                  ? "border-red-500 focus:ring-red-500"
                  : "border-gray-200",
              )}
            />

            {errors.packageDetails?.length && (
              <p className="text-sm text-red-500">
                {errors.packageDetails.length.message}
              </p>
            )}
          </div>

          <div className="flex flex-col gap-2 min-w-0">
            <label
              htmlFor="packageDetails-width"
              className="block text-sm/6 font-normal text-gray-950"
            >
              Width (in)
            </label>

            <input
              id="packageDetails-width"
              type="number"
              inputMode="decimal"
              min="0"
              autoComplete="off"
              placeholder="W"
              {...register("packageDetails.width", {
                valueAsNumber: true,
                required: "Width is required",
                validate: (value) =>
                  value > 0 || "Width must be greater than 0",
              })}
              className={clsx(
                "block w-full rounded-xl border px-4 py-3.5 text-sm outline-none",
                "focus:ring-2 focus:ring-blue-500 placeholder:text-gray-500",
                errors.packageDetails?.width
                  ? "border-red-500 focus:ring-red-500"
                  : "border-gray-200",
              )}
            />

            {errors.packageDetails?.width && (
              <p className="text-sm text-red-500">
                {errors.packageDetails.width.message}
              </p>
            )}
          </div>

          <div className="flex flex-col gap-2 min-w-0">
            <label
              htmlFor="packageDetails-height"
              className="block text-sm/6 font-normal text-gray-950"
            >
              Height (in)
            </label>

            <input
              id="packageDetails-height"
              type="number"
              inputMode="decimal"
              min="0"
              autoComplete="off"
              placeholder="H"
              {...register("packageDetails.height", {
                valueAsNumber: true,
                required: "Height is required",
                validate: (value) =>
                  value > 0 || "Height must be greater than 0",
              })}
              className={clsx(
                "block w-full rounded-xl border px-4 py-3.5 text-sm outline-none",
                "focus:ring-2 focus:ring-blue-500 placeholder:text-gray-500",
                errors.packageDetails?.height
                  ? "border-red-500 focus:ring-red-500"
                  : "border-gray-200",
              )}
            />

            {errors.packageDetails?.height && (
              <p className="text-sm text-red-500">
                {errors.packageDetails.height.message}
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
